import api from 'api'
import { CACHE_TAG_ACTION_BASED_PRICES_LIST } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getActionPricesForCS: build.query({
      query: ({ id }) => ({
        url: `/api/v1/core/configured-service/${id}/action-prices`,
      }),
      providesTags: [CACHE_TAG_ACTION_BASED_PRICES_LIST],
    }),
    updateActionPricesForCS: build.mutation({
      query: ({ id, actionPrices }) => ({
        url: `/api/v1/core/configured-service/${id}/action-prices`,
        method: 'PUT',
        body: actionPrices,
      }),
      invalidatesTags: [CACHE_TAG_ACTION_BASED_PRICES_LIST],
    }),
  }),
})

export const { useGetActionPricesForCSQuery, useLazyGetActionPricesForCSQuery, useUpdateActionPricesForCSMutation } = extendedApi
